export const countdownTime = 15; // min
export const delay = 2000; // ms

export default {
    delay,
    countdownTime
};
